import {Paper, Typography} from '@mui/material';

export interface ExerciseStatsItemProps {
  value: string | number;
  label: string;
  description: string;
  color: 'success.main' | 'secondary.main' | 'primary.main';
}

export default function ExerciseStatsItem({value, label, description, color}: ExerciseStatsItemProps) {
  return (
    <Paper sx={{p: 3, textAlign: 'center'}}>
      <Typography variant="h3" sx={{fontWeight: 700, color, mb: 1}}>
        {value}
      </Typography>
      <Typography variant="h6" sx={{color: 'text.primary', mb: 1}}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{color: 'text.secondary'}}>
        {description}
      </Typography>
    </Paper>
  );
}
